import axios from "axios";
import { getDataFromCookies } from "utilities/getCookiesData";

interface optionsLayout {
  auth?;
  err?: boolean;
  apiType?: string;
  isFormData?: boolean;
  isUrlEncoded?: boolean;
  responseType?: string;
  headers?: any;
  data?: any;
}

const API_BASE_URLS = {
  default: process.env.REACT_APP_BACKEND_SERVER_PRODUCT,
};

process.env["NODE_TLS_REJECT_UNAUTHORIZED"] = "0";

class Request {
  token: string;

  constructor() {
    axios.defaults.headers.common["Content-Type"] = "application/json;";
  }
  setToken(token) {
    axios.defaults.headers.common["Authorization"] = token ? `Bearer ${token}` : null;
  }
  // Show user the correct error message upon unsuccessful requests
  handleError(e: any, showErr = true) {
    // console.log(e);
  }

  msInstance(baseUrl) {
    const msInstance = axios.create({
      baseURL: baseUrl,
    });
    msInstance.interceptors.request.use((req) => {
      const token = getDataFromCookies("token");
      req.headers["Authorization"] = `Bearer ${token}`;
      return req;
    });
    return msInstance;
  }

  post(url: string, params: any, options?: optionsLayout & { isFormData?: boolean }) {
    return new Promise<any>((resolve, reject) => {
      let data = params;
      if (options?.isFormData) {
        data = new FormData();
        Object.keys(params).forEach((key) => {
          data.append(key, params[key]);
        });
      }
      const config: any = {};

      if (options && options.headers) {
        config.headers = options.headers;
      }

      if (options?.isUrlEncoded) {
        config.headers = {
          "content-type": "application/x-www-form-urlencoded",
        };
        data = new URLSearchParams();
        Object.keys(params).forEach((key) => {
          data.append(key, params[key]);
        });
      }

      this.msInstance(`${API_BASE_URLS[options?.apiType ? options.apiType : "default"]}`)
        .post(`${url}`, data, options?.responseType ? { responseType: options?.responseType } : config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  get(url: string, options?: optionsLayout) {
    return new Promise<any>((resolve, reject) => {
      const config: any = {};

      if (options && options.headers) {
        config.headers = options.headers;
      }

      this.msInstance(`${API_BASE_URLS[options?.apiType ? options.apiType : "default"]}`)
        .get(`${url}`, options?.responseType ? { responseType: options?.responseType } : config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          if (options && options.err === false) {
            this.handleError(e, false);
          } else {
            this.handleError(e);
          }
          reject(e);
        });
    });
  }

  put(url: string, params: any, options?: optionsLayout) {
    return new Promise<any>((resolve, reject) => {
      let data = params;
      if (options?.isFormData) {
        data = new FormData();
        Object.keys(params).forEach((key) => {
          data.append(key, params[key]);
        });
      }
      const config: any = {};

      if (options && options.headers) {
        config.headers = options.headers;
      }
      if (options?.isUrlEncoded) {
        config.headers = {
          "content-type": "application/x-www-form-urlencoded",
        };
        data = new URLSearchParams();
        Object.keys(params).forEach((key) => {
          data.append(key, params[key]);
        });
      }

      this.msInstance(`${API_BASE_URLS[options?.apiType ? options.apiType : "default"]}`)
        .put(`${url}`, data, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  patch(url: string, params: any, options?: optionsLayout) {
    return new Promise<{ data: any }>((resolve, reject) => {
      const config: any = {};

      if (options && options.headers) {
        config.headers = options.headers;
      }

      this.msInstance(`${API_BASE_URLS[options?.apiType ? options.apiType : "default"]}`)
        .patch(`${url}`, params, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  delete(url: string, options?: optionsLayout) {
    return new Promise<{ data: any }>((resolve, reject) => {
      const config: any = {};

      if (!!options?.data) {
        config.data = options.data;
      }

      if (options && options.headers) {
        config.headers = options.headers;
      }

      this.msInstance(`${API_BASE_URLS[options?.apiType ? options.apiType : "default"]}`)
        .delete(`${url}`, config)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((e) => {
          this.handleError(e);
          reject(e);
        });
    });
  }
}

export default new Request();
